<template>
  <div class="header">
    <!-- 顶部搜索框 -->
    <div class="header_img">
      <img src="../../assets/img/zhibo_lg.png" />
    </div>
    <label @click="search" class="searchLabel">
      <mt-search cancel-text="取消" placeholder="请输入直播名称"></mt-search>
    </label>
  </div>
</template>
<script>
export default {
  methods: {
    search() {
      this.$router.push('/search')
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  background-color: #fff;
  // position: fixed;
  width: 100%;
  // top: 0;
  padding-top: 1rem;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  // z-index: 100;
  .header_img {
    width: 38px;
    height: 38px;
    margin-top: 10px;
    img {
      width: 100%;
    }
  }
}
.searchLabel {
  width: 82%;

  margin-left: 5px;
}
/deep/ .mint-search {
  box-sizing: border-box;
  height: 100%;
}
/deep/ .mint-searchbar {
  background-color: #fff;
  box-sizing: border-box;
  margin-top: 1rem;
  padding: 0 0.5rem;
  width: 100%;
}
/deep/ .mint-searchbar-inner {
  background-color: #eee;
  padding: 0.5rem 2rem;
  border-radius: 4rem;
  font-size: 14px;
  height: 35px;
}
/deep/ .mint-searchbar-inner .mintui-search {
  font-size: 14px;
}
/deep/ .mint-searchbar-core {
  background-color: #eee;
  padding-left: 1rem;
}
</style>
